import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Loader from "../../../shared/loader";
import AppAlert from "../../../shared/appAlert";
import { Collapse, Typography,Empty,Tooltip} from "antd";
import { clearMerchantData, fetchMerchantDetailes } from "./reducer";
import CoinList from "../../shared.component/coinList";
import Merchant from "./merchant";


const { Title } = Typography;

const { Panel } = Collapse;
const MerchantComponent = (props) => {
  const [showModal, setIsshowModal] = useState(false);
  const fields = { currencyCode: 'code', currencyFullName: 'walletName', amount: 'balance', percentage: 'percentage', showTradebtn: false, istradeText: true, logo: 'logo' }
  const [coinListData, setCoinListData] = useState([]);
  useEffect(() => {
    props.dispatch(fetchMerchantDetailes(props?.userConfig?.id));
    return ()=>{
      props.dispatch(clearMerchantData())
    }
  }, [])
  useEffect(() => {
    if (props?.merchantData?.merchants?.data?.length > 0) {
      setCoinListData(props?.merchantData?.merchants?.data);
    }
  }, [props?.merchantData?.merchants])
  const handlemodal = () => {
    setIsshowModal(true)
  }
  const setshowModal = () =>{
    setIsshowModal(false);
  }

  return (<>
  {props?.merchantData?.merchants?.error  && props?.merchantData?.merchants?.error !== null && props?.merchantData?.merchants?.error !== "" && (
          <div className="alert-flex" style={{ width: "100%" }}>
            <AppAlert
              className="w-100 "
              type="warning"
              description={props?.merchantData?.merchants?.error}
              showIcon
            />
          </div>
        )}
   { props?.merchantData?.merchants?.loader === true ? <Loader />:<div className="left-panel pannel-bg mb-leftpanel mb-0 merchants-section">
      <div className='custom-flex'>
        <Title level={6} className="card-title">Merchant Accounts</Title>
        <Tooltip placement="top" title="Add Merchant" onClick={handlemodal}>
         <span className='icon sm add-coin c-pointer' /></Tooltip>
      </div>
      
      <Collapse accordion defaultActiveKey={['1']} >
      {coinListData?.length === 0 && !props?.merchantData?.merchants?.loader && <div className="h-full d-flex align-items-center justify-center">
       
        <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Data"
              ></Empty></div>}
        {coinListData.map((merchant, index) => (
          <Panel header={<> <p title={merchant.merchantName}>{merchant.merchantName}</p> </>} key={index + 1}>
            <div>

              <CoinList
                coinSearch={true}
                coinList={merchant.merchantsDetails}
                coinFields={fields}
              />
            </div>
          </Panel>
        ))}
      </Collapse>
    </div>}

   {showModal && <Merchant showModal = {showModal} setIsshowModal = {setshowModal}/>}
  </>
  )
}
const connectStateToProps = ({ merchantData, userConfig }) => {
  return { userConfig: userConfig.userProfileInfo, merchantData: merchantData };
};
const connectDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
MerchantComponent.propTypes = {
  userConfig: PropTypes.object,
  dispatch: PropTypes.func,
};
export default connect(
  connectStateToProps,
  connectDispatchToProps
)(MerchantComponent);